/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateDepartmentRequestBody = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
        phonenumbers: {
    type: 'array',
    contains: {
        type: 'DepartmentPhoneNumberRequestBody',
    },
},
    },
};